import React from "react";
import { FiGrid } from "react-icons/fi";
import ImageThumbnail from "./ImageThumbnail";

const ImageDisplay = ({
  originalImage,
  results,
  selectedImage,
  onSelectImage,
  onOpenFullScreen,
}) => {
  // Group results by API call (using editType and approximate timestamp from id)
  const groupResultsByApiCall = () => {
    const groups = [];
    const processedIds = new Set();

    const sortedResults = [...results].sort((a, b) => a.id - b.id);

    sortedResults.forEach(result => {
      if (processedIds.has(result.id)) return;

      const groupResults = sortedResults.filter(r =>
        r.editType === result.editType &&
        Math.abs(r.id - result.id) < 100 &&
        !processedIds.has(r.id)
      );

      groupResults.forEach(r => processedIds.add(r.id));

      if (groupResults.length > 0) {
        groups.push({
          editType: result.editType,
          timestamp: result.id,
          results: groupResults
        });
      }
    });

    return groups;
  };

  const resultGroups = groupResultsByApiCall();

  return (
    <div>
      {/* Image Gallery Header */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: "1.5rem" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FiGrid style={{ fontSize: "1.4rem", color: "#4D7CFE", marginRight: "0.75rem" }} />
          <h2 style={{ fontSize: "1.3rem", fontWeight: "600", margin: 0, color: "#333" }}>
            Image Gallery
          </h2>
        </div>
      </div>

      {/* Original Image */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
        gap: "1.5rem",
        paddingBottom: "2rem",
        justifyItems: "center"
      }}>
        <div style={{
          position: "relative",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
          backgroundColor: "white",
          transition: "transform 0.2s ease",
          width: "250px",
          height: "250px"
        }}>
          <ImageThumbnail
            image={{ type: "original", url: originalImage }}
            isSelected={selectedImage?.type === "original"}
            onClick={() =>
              onSelectImage({ type: "original", url: originalImage })
            }
            onOpenFullScreen={() => onOpenFullScreen(originalImage)}
          />
        </div>
      </div>

      {/* Results sections */}
      {resultGroups.map((group, groupIndex) => (
        <div key={`group-${group.timestamp}`} className="result-section" style={{ marginTop: "2rem" }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "1.5rem",
            borderTop: groupIndex > 0 ? "1px solid #e0e7ff" : "none",
            paddingTop: "1.5rem"
          }}>
            <h2 style={{
              fontSize: "1.3rem",
              fontWeight: "600",
              margin: 0,
              color: "#333"
            }}>
              Result
            </h2>
          </div>

          <div style={{
            display: "flex",
            overflowX: "auto",
            gap: "1.5rem",
            paddingBottom: "1rem",
            scrollbarWidth: "thin",
            scrollbarColor: "#d4d4d4 #f4f4f4"
          }}>
            {group.results.map((result) => (
              <div
                key={result.id}
                style={{
                  position: "relative",
                  borderRadius: "8px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                  backgroundColor: "white",
                  transition: "transform 0.2s ease",
                  width: "250px",
                  height: "250px",
                  flex: "0 0 auto"
                }}
              >
                <ImageThumbnail
                  image={result}
                  isSelected={selectedImage?.id === result.id}
                  onClick={() =>
                    onSelectImage({ id: result.id, url: result.url, type: "result" })
                  }
                  onOpenFullScreen={() =>
                    onOpenFullScreen(result.url, result.baseImageId)
                  }
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageDisplay;